import api from "@/lib/api";

const mql = typeof window !== "undefined" && window.matchMedia
  ? window.matchMedia("(prefers-color-scheme: dark)") : null;
const osTheme = () => (mql && mql.matches ? "dark" : "light");

// Resolve a stored preference ("auto" | "light" | "dark") to an actual theme.
const resolve = (pref) => (pref === "auto" ? osTheme() : (pref === "light" ? "light" : "dark"));

// The currently-applied (resolved) theme — dark is the default.
export const currentTheme = () => (localStorage.getItem("nc_theme") === "light" ? "light" : "dark");

// Apply a preference locally (resolving "auto") and notify listening nav toggles.
export const applyTheme = (pref) => {
  const p = ["auto", "light", "dark"].includes(pref) ? pref : "dark";
  const resolved = resolve(p);
  document.documentElement.classList.toggle("dark", resolved === "dark");
  localStorage.setItem("nc_theme", resolved);
  localStorage.setItem("nc_theme_pref", p);
  window.dispatchEvent(new Event("nc-theme-changed"));
};

// Persist the signed-in user's preference ("auto"/"light"/"dark") to their account.
export const saveThemeToAccount = (pref) => {
  const p = ["auto", "light", "dark"].includes(pref) ? pref : "dark";
  api.put("/profile/theme", { theme: p }).catch(() => {});
};

// Persist the signed-in user's UI language to their account.
export const saveLangToAccount = (lang) => {
  if (["en", "es", "vi"].includes(lang)) api.put("/profile/theme", { lang }).catch(() => {});
};

// On login, adopt the account's saved preference so it follows the user.
export const syncThemeFromAccount = async () => {
  try {
    const { data } = await api.get("/profile");
    if (data && ["light", "dark", "auto"].includes(data.theme)) applyTheme(data.theme);
  } catch { /* not logged in / no profile */ }
};

// Live-update when the OS scheme changes while the user is in Auto mode.
if (mql && mql.addEventListener) {
  mql.addEventListener("change", () => {
    if (localStorage.getItem("nc_theme_pref") === "auto") applyTheme("auto");
  });
}
